export const fetchSearchOptions = async (geoserverUrl, layerName, variableName) => {
    if (geoserverUrl && layerName && variableName) {
        const url = `${geoserverUrl}?service=WFS&version=1.0.0&request=GetFeature&typeName=${layerName}&outputFormat=application/json&propertyName=${variableName}`;
        const response = await fetch(url);
        const data = await response.json();
        const dpaList = data.features.map(feature => ({
            name: feature.properties[variableName],
            bbox: feature.bbox
        }));
        return dpaList;
    } else {
        return '';
    }
};